import { useMutation } from '@tanstack/react-query'
import invariant from 'tiny-invariant'

import { nonceFetcher, NonceType } from './use-nonce'

const CF_URL = process.env.NEXT_PUBLIC_CF_URL || process.env.VITE_CF_URL

invariant(
  CF_URL,
  'NEXT_PUBLIC_CF_URL or VITE_CF_URL is required inside use-undo-subscription-cancel',
)

async function restoreSubscriptionFetcher(subscriptionId?: string) {
  if (!subscriptionId) {
    return
  }

  try {
    const { nonce } = await nonceFetcher(NonceType.UNDO_SUBSCRIPTION_CANCELLATION)
    const formData = new FormData()
    formData.append('sub_id', subscriptionId)
    formData.append('security', nonce)

    const res = await fetch(
      `${CF_URL}/wp-admin/admin-ajax.php?action=undo_subscription_cancellation`,
      {
        method: 'POST',
        credentials: 'include',
        body: formData,
      },
    )

    const textResponse = await res.text()

    try {
      const fetchData = JSON.parse(textResponse)
      return fetchData
      // oxlint-disable-next-line unicorn/catch-error-name
    } catch (err) {
      throw new Error('Restore subscription response is not JSON')
    }
    // oxlint-disable-next-line unicorn/catch-error-name
  } catch (er) {
    throw new Error('Failed to restore subscription using WP api')
  }
}

// eslint-disable-next-line cf-web/codegen-mutation-returns
export function useUndoSubscriptionCancel(
  subscriptionId?: string,
  onError?: (error: Error) => void,
) {
  return useMutation<undefined, Error>({
    mutationKey: [`/wp-admin/admin-ajax.php_undo_subscription_cancellation${subscriptionId ?? ''}`],
    mutationFn: () => restoreSubscriptionFetcher(subscriptionId),
    onError,
  })
}
